var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVending = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#183558",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M1.464 9H1a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5h2.393M8.536 9H9a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H6.607"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#183558",
  strokeLinecap: "round",
  d: "M2 13.5h12M3.5 15h9"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#183558",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.5 11.344v-8.04L11.333 1.5h2.834L15.5 2.648V12"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#183558",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11 2v9.5h3M11 9h3M11 6.5h3M11 4h3"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#183558",
  fillRule: "evenodd",
  d: "M4.996 10.514c.23-.357.52-.823.809-1.332.32-.565.628-1.166.854-1.724.236-.58.341-1.017.341-1.282C7 4.922 6.055 4.004 5.006 4c-1.05.016-1.99.931-2.006 2.181.001.266.107.701.341 1.28.226.56.535 1.163.855 1.73.285.504.57.966.8 1.323M4.65 11.8A.5.5 0 0 0 5 12a.47.47 0 0 0 .35-.217S8 8.029 8 6.176C8 4.422 6.657 3 5 3c-1.649.02-2.981 1.43-3 3.176C2 8.03 4.65 11.8 4.65 11.8M5 6.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
  clipRule: "evenodd"
})));
export default SvgVending;